"use client";
import React from "react";
import Table from "@/components/primitives/table";
import { ColumnDef } from "@tanstack/react-table";
import BettorDisplay from "./bettor-display";
import TablePagination, {
  TablePaginationProps,
} from "../primitives/table-pagination";
import { BettorRelationshipsModel } from "common";
import BettorRelationshipActions, { FollowActions } from "./relationship-actions";

export default function FollowTable({
  data,
  pagination,
}: {
  data: BettorRelationshipsModel[];
  pagination: TablePaginationProps;
}) {
  console.log("following data", data);

  const columns: ColumnDef<BettorRelationshipsModel>[] = React.useMemo(() => {
    if (!data || data.length === 0) return [];
    return [
      {
        header: "username",
        size: 200,
        cell: (info) => {
          const row = info.row.original;
          return (
            <>
              <BettorDisplay
                bettor={{
                  id: row.bettor_id,
                  displayName: row.display_name,
                  avatarUrl: row.avatar_url,
                  totalUnits: row.last25Record?.unitsGained ?? 0,
                  activePicks: row.active_picks || 0,
                  totalPicks: 0,
                }}
                disableLastPicks
                noCard
              />
            </>
          );
        },
      },
      // {
      //   header: "units",
      //   size: 90,
      //   accessorKey: "units",
      //   cell: (info) => {
      //     return `${formatDiff(info.getValue() as number)}`;
      //   },
      // },
      // {
      //   header: "overall",
      //   size: 90,
      //   accessorFn: (row) =>
      //     `${row.allTime.wins}-${row.allTime.losses}-${row.allTime.ties}`,
      // },
      // {
      //   header: "last 10",
      //   size: 90,
      //   accessorFn: (row) =>
      //     `${row.last10.wins}-${row.last10.losses}-${row.last10.ties}`,
      // },
      // {
      //   header: "last 100",
      //   size: 90,
      //   accessorFn: (row) =>
      //     `${row.last100.wins}-${row.last100.losses}-${row.last100.ties}`,
      // },
      {
        header: () => (
          <div className="flex justify-end w-full pr-1">Actions</div>
        ),
        id: "actions",
        size: 120,
        cell: (info) => {
          const row = info.row.original;
          return (
            <div className="flex justify-end w-full">
              <BettorRelationshipActions
                type="target-profile"
                target={{
                  bettor: {
                    id: row.bettor_id,
                    displayName: row.display_name,
                    avatarUrl: row.avatar_url,
                    totalUnits: row.last25Record?.unitsGained ?? 0,
                    activePicks: row.active_picks || 0,
                    totalPicks: 0,
                  },
                  high_voltage:
                    row.perspective?.high_voltage_notifications || false,
                  following: row.perspective?.following || false,
                  disabled: row.perspective?.is_self || false,
                  relationship_notification_channel_flags: row.perspective?.notification_channel_flags
                }}
              >
                <FollowActions />
              </BettorRelationshipActions>
            </div>
          );
        },
      },
    ];
  }, [data, pagination]);
  return (
    <Table
      columns={columns}
      data={data}
      type="standard"
      initialSort={{ column: "units", direction: "desc" }}
      footer={
        <TablePagination
          page={pagination.page}
          size={pagination.size}
          count={pagination.count}
          onPageChange={pagination.onPageChange}
          onPageSizeChange={pagination.onPageSizeChange}
        />
      }
    />
  );
}
